module.exports = __webpack_public_path__ + "media/assets/og_generic_image-d2a3a15c.png";